import type { WhitelabelVariantDefinition } from '../../types';

export const leadzaiWhitelabel = {
  id: 'leadzai',
  colors: {
    primary: {
      900: '#002962',
      800: '#003A8C',
      700: '#096DD9',
      500: '#48ACFF',
      300: '#91D5FF',
      100: '#E6F7FF',
      contrastText: '#FFFFFF',
    },
  },
} as const;

export const leadzaiDefaultTheme: WhitelabelVariantDefinition = {
  palette: {
    primary: {
      darker: leadzaiWhitelabel.colors.primary[900],
      dark: leadzaiWhitelabel.colors.primary[800],
      main: leadzaiWhitelabel.colors.primary[700],
      light: leadzaiWhitelabel.colors.primary[500],
      lighter: leadzaiWhitelabel.colors.primary[300],
      muted: leadzaiWhitelabel.colors.primary[100],
      contrastText: leadzaiWhitelabel.colors.primary.contrastText,
    },
  },
  typography: { fontFamily: 'DM Sans' },
};
